/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-sequences */
import React from 'react';
import Components from 'mpm-components';
import Services from 'mpm-services';
import { Form, Button, Icon, Divider, Input, Grid, FormTextArea, Checkbox } from 'semantic-ui-react';
import Utilities from 'mpm-config/Utilities';
import MPMContext from 'mpm-config/context/MPMContext';
import { SourceEXView } from 'mpm-classes/CessionExport';
import { toClass } from 'class-converter';
import NumberFormat from 'react-number-format';

export default ({ cessionExport, setCessionExport, setMessage, editMode, onComplet }) => {
  const defaultChecked = cessionExport.childrenSourceEXP.map((elem) => elem.sourceEXPList).flat();
  const [checkedSourceExpList, setCheckedSourceExpList] = React.useState(defaultChecked);
  const [loadingSource, setLoadingSource] = React.useState(false);
  const [savingSourceExp, setSavingSourceExp] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [modalData, setModalData] = React.useState({ open: false });
  const [source, setSource] = React.useState(new SourceEXView());
  const [sourceIndex, setSourceIndex] = React.useState(cessionExport.childrenSourceEXP ? cessionExport.childrenSourceEXP.length : 0);
  const [sourceError, setSourceError] = React.useState(false);
  const [sourceEspeceCriteria, setSourceEspeceCriteria] = React.useState({ refEspece: null, refTransf: null, codeSH: 0, loading: false, disabled: false });
  const [especesDropDownOptions, setEspecesDropDownOptions] = React.useState([]);
  const [typesTransformations, setTypesTransformations] = React.useState({
    loading: true,
    error: false,
    data: [],
  });
  const onChangeSource = (name, value) => {
    let _source = source;
    _source = {
      ...source,
      [name]: value,
    };
    setSourceError(false);
    let found = false;
    cessionExport.childrenSourceEXP &&
      cessionExport.childrenSourceEXP.forEach((elem) => {
        if (elem.typeSource === _source.typeSource && elem.codeSource === _source.codeSource) {
          found = true;
        }
      });
    if (found) {
      setSourceError(true);
    }
    setSource(_source);
  };

  const onAddSource = () => {
    setIsEdit(false);
    setSource(new SourceEXView());
    setSourceIndex(cessionExport.childrenSourceEXP ? cessionExport.childrenSourceEXP.length : 0);
    setSourceEspeceCriteria({ refEspece: null, refTransf: null, codeSH: 0, loading: false, disabled: false });
  };

  const onLoadSource = () => {
    if (Utilities.isNotNull(cessionExport.dateCession) && Utilities.isNotNull(source.typeSource) && Utilities.isNotNull(source.codeSource)) {
      setLoadingSource(true);
      setMessage(null);
      setTypesTransformations({
        loading: true,
        error: false,
        data: [],
      });
      Services.CessionsExportDataService.chargerSourcesExp({
        dateCession: cessionExport.dateCession,
        typeSource: source.typeSource,
        codeSource: source.codeSource,
        categoriePeche: cessionExport.categoriePeche,
      })
        .then((result) => {
          setLoadingSource(false);
          if (!result.success) {
            setMessage({
              error: true,
              header: 'Chargement de source',
              content: result.message,
            });
            setSource(new SourceEXView());
            return;
          }
          // if(result.data.childrenSrcEsp && result.data.childrenSrcEsp.length === 0){
          //   setMessage({
          //     warning: true,
          //     header: "Chargement de source",
          //     content: "Aucune especes trouvées pour cette source",
          //   });
          //   setSource(new SourceEXView());
          //   return;
          // }
          setSourceEspeceCriteria({ ...sourceEspeceCriteria, disabled: false });
          let _result = {
            ...result.data,
            typeSource: source.typeSource,
            codeSource: source.codeSource,
            allChildrenSrcEsp: result.data.childrenSrcEsp,
            childrenSrcEsp: [],
          };
          setTypesTransformations({
            loading: false,
            error: false,
            data: Utilities.getCPTransformationDropDownOptions(_result.allChildrenSrcEsp),
          });
          _result.allChildrenSrcEsp.map((espece) => {
            espece.id = null;
            espece.rendementGH = espece.rendementG;
            return espece;
          });
          setEspecesDropDownOptions(Utilities.getCPEspecesDropDownOptions(_result.allChildrenSrcEsp));

          constructDelaisNineDays([result]);
          setSource(new SourceEXView());
          setTimeout(() => {
            setSource(toClass(_result, SourceEXView));
            //updateStore(toClass(_result, SourceEXView));
          }, 100);
        })
        .catch((error) => {
          setTypesTransformations({
            loading: false,
            error: true,
            data: [],
          });
          setMessage({
            error: true,
            header: 'Chargement de source',
            content: `Une erreur est survenue lors de chargement de la source ${source.codeSource}`,
          });
          setLoadingSource(false);
        });
    }
  };
  const constructDelaisNineDays = (rows = []) => {
    let messages = [];

    rows.forEach((elem) => {
      if (Utilities.isNotNull(elem.message)) {
        messages.push(elem.message);
      }
    });
    if (messages.length > 0) {
      setMessage({
        error: true,
        header: 'Attention !!',
        content: messages,
        isArrray: true,
      });
    }
  };
  const onSelectEspeces = (selectedEspeces) => {
    let allChild = [];
    source.allChildrenSrcEsp.forEach((elem) => {
      let foundEspece = selectedEspeces.find((sel) => sel === elem);
      if (foundEspece) {
        if ((!foundEspece.poidExporte || Number(foundEspece.poidExporte) === Number(0)) && Number(foundEspece.rendementG) > 0) {
          foundEspece.poidCD = foundEspece.disponible;
          foundEspece.poidExporte = foundEspece.poidCD * foundEspece.rendementG;
        }
        elem = foundEspece;
      } else {
        elem.poidExporte = 0;
        elem.poidCD = 0;
      }
      allChild.push(elem);
    });
    let _source = {
      ...source,
      allChildrenSrcEsp: [...allChild],
      childrenSrcEsp: allChild.filter((el) => el.selected),
    };
    if (selectedEspeces.length === 0) {
      _source.sourceEXPList = [];
    }
    setSource(_source);
    updateStore(_source);
  };

  // const onChangeEspeceQuantite = (espece, event) => {

  //   let _source = {...source};
  //   let index = _source.allChildrenSrcEsp.indexOf(espece);
  //   let nextValue = event.target.value;
  //   if(Utilities.isNumber(nextValue)){
  //     espece.quantiteCD = nextValue;
  //     espece.quantite = nextValue;
  //     espece.poidCD = nextValue
  //   }
  //   if(espece.rendementGH === 0){
  //     espece.rendementG = Number(espece.quantiteCD / espece.poidCD).toFixed(2);
  //   }
  //   _source.allChildrenSrcEsp[index] = espece;
  //   _source.childrenSrcEsp = _source.allChildrenSrcEsp.filter(item => item.selected);
  //   setSource({
  //     ..._source,
  //   });
  // };

  const onSaveSourceCP = () => {
    setMessage(null);
    let _source = { ...source };
    let messages = [];
    _source.childrenSrcEsp.forEach((elem) => {
      if (!(Utilities.isNumber(elem.poidCD) && elem.poidCD > 0)) {
        messages.push(`Poids CD: ${elem.poidCD} pour l'espece ${elem.refEspece.libelle} est invalide`);
      }
      if (!(Utilities.isNumber(elem.poidExporte) && elem.poidExporte > 0)) {
        messages.push(`Poids Exporté:  ${elem.poidExporte} pour l'espece ${elem.refEspece.libelle} est invalide`);
      }
    });
    if (messages && messages.length > 0) {
      setMessage({
        warning: true,
        isArray: true,
        header: 'Validation Especes',
        content: messages,
      });
    } else {
      if (isEdit) {
        _source.sourceEXPList = [];
      } else {
        _source.sourceEXPList = checkedSourceExpList;
      }
      setSavingSourceExp(true);
      Services.CessionsExportDataService.saveSourceExp({ ..._source })
        .then((result) => {
          if (result.success) {
            _source = {
              ..._source,
              sourceEXPList: fillCheckedSourceEXPList(_source),
            };

            updateStore(_source);
            onAddSource();
          } else {
            setMessage({
              warning: true,
              header: 'Enregistrement source',
              content: result.message,
            });
          }
          setSavingSourceExp(false);
        })
        .catch((error) => {
          setMessage({
            error: true,
            header: 'Enregistrement source',
            content: "Une erreur est survenue lors d'enregistrement de la source",
          });
          setSavingSourceExp(false);
        });
    }
  };

  const onEditSource = (_source) => {
    setIsEdit(true);
    setSource(new SourceEXView());
    const index = cessionExport.childrenSourceEXP.indexOf(_source);
    setTimeout(() => {
      setSourceIndex(index);
      if (editMode) {
        _source.allChildrenSrcEsp = _source.childrenSrcEsp;
        setSourceEspeceCriteria({ ...sourceEspeceCriteria, disabled: true });
      } else {
        setSourceEspeceCriteria({ ...sourceEspeceCriteria, disabled: false });
      }
      setTypesTransformations({
        loading: false,
        error: false,
        data: Utilities.getCPTransformationDropDownOptions(_source.allChildrenSrcEsp),
      });
      setEspecesDropDownOptions(Utilities.getCPEspecesDropDownOptions(_source.allChildrenSrcEsp));

      setSource(_source);
    }, 50);
  };
  const fillCheckedSourceEXPList = (sourceCP) => {
    if (sourceCP) {
      let tab = [...checkedSourceExpList];
      if (sourceCP.id_RefSrc && tab.indexOf(sourceCP.id_RefSrc) === -1) {
        tab.push(sourceCP.id_RefSrc);
      }

      setCheckedSourceExpList(tab);
      return tab;
    }
    return [];
  };
  const getSourceCPList = (sourceCP) => {
    if (sourceCP) {
      let tab = [];
      if (sourceCP.id_RefSrc && tab.indexOf(sourceCP.id_RefSrc) === -1) {
        tab.push(sourceCP.id_RefSrc);
      }
      return tab;
    }
    return [];
  };

  const onDeleteSource = (_source) => {
    let cc = cessionExport;
    setModalData({ ...modalData, loadingConfirm: true });
    if (cc.etat === '0') {
      let totalIds =
        cc.childrenSourceEXP &&
        cc.childrenSourceEXP
          .map((elem) => elem.id)
          .flat()
          .filter((elem) => elem);
      if (editMode && totalIds && _source.id && totalIds.length === 1) {
        Services.CessionsExportDataService.delete({ id: cc.id, etat: cc.etat })
          .then((result) => {
            setModalData({ open: false });
            if (result.data.success) {
              setMessage({
                success: true,
                header: "Suppression cession d'exportation",
                content: "Cession d'export a été supprimer avec succée.",
              });
              onComplet(true);
            } else {
              setMessage({
                error: true,
                header: 'Suppression de la source',
                content: result.data.message,
              });
            }
          })
          .catch((error) =>
            setMessage({
              error: true,
              header: 'Suppression de la source',
              content: 'Erreur lors de suppression de la source',
            })
          );
        return;
      } else {
        if (_source.id) {
          Services.CessionsExportDataService.deleteSourceExp(_source.id)
            .then((result) => {
              if (result.success) {
                afterDeleteSuccess(cc, _source);
              } else {
                setModalData({ open: false });
                setMessage({
                  error: true,
                  header: 'Suppression de la source',
                  content: result.message,
                });
              }
            })
            .catch((error) => {
              setModalData({ open: false });
              setMessage({
                error: true,
                header: 'Suppression de la source',
                content: 'Erreur lors de suppression de la source',
              });
            });
        } else {
          afterDeleteSuccess(cc, _source);
          return;
        }
      }
    } else {
      afterDeleteSuccess(cc, _source);
    }
    /*   setIsEdit(false);
    setSource(new SourceEXView())
    setSourceIndex(cessionExport.childrenSourceEXP.length); */
  };

  const afterDeleteSuccess = (cc, source) => {
    let newChecked = [...checkedSourceExpList];
    let index = cc.childrenSourceEXP.indexOf(source);
    let _sourceCPList = getSourceCPList(source);
    cc.childrenSourceEXP.map((elem) => {
      _sourceCPList.forEach((ss) => {
        //elem.sourceEXPList.splice(elem.sourceEXPList.indexOf(ss), 1);
        newChecked.splice(newChecked.indexOf(ss), 1);
      });
      return elem;
    });
    setCheckedSourceExpList(newChecked);
    cc.childrenSourceEXP.splice(index, 1);
    setCessionExport({ ...cc });
    setModalData({ open: false });
    onAddSource();
  };

  const updateStore = (_source) => {
    let _newCessionExport = { ...cessionExport };
    if (_newCessionExport.childrenSourceEXP[sourceIndex] !== undefined) {
      _newCessionExport.childrenSourceEXP[sourceIndex] = _source;
    } else {
      _newCessionExport.childrenSourceEXP.push(_source);
    }
    if (!_newCessionExport.categoriePeche) {
      _newCessionExport.categoriePeche = _source.categoriePeche;
    }
    setCessionExport({ ..._newCessionExport });
  };

  const onChangeEspecePoidCD = (espece, name, value) => {
    //RG = PoidExoprte / PoidCD   --   pE = RG*PoidCD
    let _source = { ...source };
    let index = _source.allChildrenSrcEsp.indexOf(espece);
    value = Number(value.split(' ').join(''));
    if (value <= espece.disponible) {
      espece[name] = value;
      espece.poidExporte = espece.poidCD * espece.rendementG;
    }
    _source.allChildrenSrcEsp[index] = espece;
    _source.childrenSrcEsp = _source.allChildrenSrcEsp.filter((item) => item.selected);
    setSource({
      ..._source,
    });
  };
  const onChangeEspecePoidExporte = (espece, name, value) => {
    //RG = PoidExoprte / PoidCD   --   pE = RG*PoidCD
    let _source = { ...source };
    let index = _source.allChildrenSrcEsp.indexOf(espece);
    value = Number(value.split(' ').join(''));
    let poidCD = value / espece.rendementG;
    if (poidCD <= espece.disponible) {
      espece[name] = value;
      espece.poidCD = poidCD;
    }
    _source.allChildrenSrcEsp[index] = espece;
    _source.childrenSrcEsp = _source.allChildrenSrcEsp.filter((item) => item.selected);
    setSource({
      ..._source,
    });
  };
  const onChangeEspeceData = (espece, name, value) => {
    //RG = PoidExoprte / PoidCD   --   pE = RG*PoidCD
    let _source = { ...source };
    let index = _source.allChildrenSrcEsp.indexOf(espece);
    espece[name] = value;
    _source.allChildrenSrcEsp[index] = espece;
    _source.childrenSrcEsp = _source.allChildrenSrcEsp.filter((item) => item.selected);
    setSource({
      ..._source,
    });
  };

  const onClickPasserLignes = () => {
    let _source = { ...source };
    const _allChildrenEspeces = _source.allChildrenSrcEsp.map((espece) => {
      if (espece.selected) {
        const { codeSH, refEspece, refTransf } = sourceEspeceCriteria;
        if (refEspece && Utilities.isNotNull(refEspece.id) && refEspece.id === espece.refEspece.id) {
          if (refTransf && Utilities.isNotNull(refTransf.id) && refTransf.id === espece.refTypeTransf.id) {
            espece.codeSH = codeSH;
          }
        }
      }
      return espece;
    });

    _source.allChildrenSrcEsp = _allChildrenEspeces;
    _source.childrenSrcEsp = _allChildrenEspeces.filter((item) => item.selected);

    setSource({ ..._source });
    setTimeout(() => {
      setSourceEspeceCriteria({ ...sourceEspeceCriteria, loading: false });
    }, 100);
  };

  const getDeleteContent = (cession, clickedSource) => {
    let deleteCession = false;
    if (editMode) {
      deleteCession =
        clickedSource.id &&
        cession.childrenSourceEXP
          .map((elem) => elem.id)
          .flat()
          .filter((elem) => elem).length === 1;
    } else {
      deleteCession = clickedSource.id && cession.childrenSourceEXP.length === 1;
    }
    if (deleteCession) {
      return "Êtes vous sur de bien vouloir supprimer cette source ? Attention la demande d'export va être supprimer !!";
    } else {
      return 'Êtes vous sur de bien vouloir supprimer cette source ? ';
    }
  };

  return (
    <MPMContext.Consumer>
      {(context) => (
        <>
          <Grid columns="equal">
            <Grid.Column computer={5} mobile={16} stretched>
              <Components.Regions.RegionWithHeader title="label.sources" headerColor="blue" headerSize="small">
                <Components.Tables.SmartTable
                  header={[
                    {
                      selector: 'codeSource',
                      collapsing: false,
                      label: 'Source',
                      positive: (row) => !row.id,
                      component: (row) => (
                        <>
                          {Utilities.getTypeSourceName(row.typeSource)} <br /> {row.codeSource}
                        </>
                      ),
                    },
                    {
                      selector: 'codeSource',
                      collapsing: true,
                      label: 'Actions',
                      positive: (row) => !row.id,
                      component: (row) => (
                        <Button.Group size="mini">
                          <Button onClick={() => onEditSource(row)} icon>
                            {editMode ? <Icon name="eye" /> : <Icon name="edit" />}
                          </Button>
                          <Button icon negative onClick={() => setModalData({ data: row, open: true, title: 'Confirmation de supression', content: getDeleteContent(cessionExport, row), loadingConfirm: false })}>
                            <Icon name="trash" />
                          </Button>
                        </Button.Group>
                      ),
                    },
                  ]}
                  data={cessionExport.childrenSourceEXP}
                  selectable={false}
                  grouped={false}
                  pagination={true}
                  rowsPerPage={5}
                  striped={true}
                  sortable={true}
                />
              </Components.Regions.RegionWithHeader>
            </Grid.Column>
            <Grid.Column>
              <Components.Regions.RegionWithoutHeader>
                <Form size="small">
                  <Form.Group widths="equal">
                    <Form.Dropdown label="Type Source" selection disabled={isEdit} value={source.typeSource} options={Utilities.getCPTypeSourceDropDownOptions()} onChange={(event, { value }) => onChangeSource('typeSource', value)} />
                    <Form.Input
                      label="Code Source"
                      name="codeSource"
                      size="small"
                      disabled={isEdit}
                      error={sourceError}
                      value={source.codeSource}
                      onChange={({ target }) => onChangeSource('codeSource', target.value)}
                      action={
                        <Button disabled={sourceError} loading={loadingSource} onClick={() => onLoadSource()} positive>
                          Charger
                        </Button>
                      }
                    />
                  </Form.Group>
                </Form>
              </Components.Regions.RegionWithoutHeader>
            </Grid.Column>
          </Grid>
          <Grid columns="equal">
            <Grid.Column>
              <Components.Regions.RegionWithHeader title="label.especes" headerColor="blue" headerSize="small" loading={loadingSource} className="scrolling-x">
                {source.allChildrenSrcEsp && source.allChildrenSrcEsp.length > 0 && (
                  <>
                    {!(editMode && isEdit) && (
                      <Form size="small" novalidation>
                        <Form.Group widths="equal">
                          <Form.Dropdown disabled={sourceEspeceCriteria.disabled} value={sourceEspeceCriteria.refEspece} selection search clearable options={especesDropDownOptions} label="Especes" onChange={(e, { value }) => setSourceEspeceCriteria({ ...sourceEspeceCriteria, refEspece: value })} />
                          <Form.Dropdown disabled={sourceEspeceCriteria.disabled} value={sourceEspeceCriteria.refTransf} selection search clearable options={typesTransformations.data} error={typesTransformations.error} loading={typesTransformations.loading} label="Types Transformation" onChange={(e, { value }) => setSourceEspeceCriteria({ ...sourceEspeceCriteria, refTransf: value })} />
                          <Form.Input
                            disabled={sourceEspeceCriteria.disabled}
                            value={sourceEspeceCriteria.codeSH}
                            label="Code SH"
                            required
                            onChange={(e, { value }) => setSourceEspeceCriteria({ ...sourceEspeceCriteria, codeSH: value })}
                            action={
                              <Button disabled={source.childrenSrcEsp.length < 1 || !sourceEspeceCriteria.codeSH || !sourceEspeceCriteria.refEspece || !sourceEspeceCriteria.refTransf} icon positive={true} onClick={() => onClickPasserLignes()} loading={sourceEspeceCriteria.loading}>
                                <Icon name="check" />
                              </Button>
                            }
                          />
                        </Form.Group>
                      </Form>
                    )}
                    <Components.Tables.SmartTable
                      header={[
                        {
                          selector: 'sourceDetail',
                          label: 'Source',
                          component: (row) => <FormTextArea disabled={editMode} value={row.sourceDetail} rows={2} />,
                        },
                        {
                          selector: 'navire',
                          label: 'Navire',
                        },
                        {
                          selector: 'refEspece.libelle',
                          textAlign: 'center',
                          label: 'Espece',
                        },
                        {
                          selector: 'refTypeTransf.nom',
                          textAlign: 'center',
                          label: 'Type Transformation',
                        },
                        {
                          selector: 'disponible',
                          textAlign: 'center',
                          label: 'Disponible en (KG)',
                          component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.disponible} />,
                        },
                        {
                          selector: 'poidCD',
                          textAlign: 'center',
                          label: 'Poids CD (KG)',
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={!(editMode && isEdit) ? 'input' : 'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} disabled={editMode && isEdit} value={row.poidCD} error={!Utilities.isNumber(row.poidCD) || row.poidCD === 0} onChange={(evt) => onChangeEspecePoidCD(row, 'poidCD', evt.target.value)} />,
                        },
                        {
                          selector: 'poidExporte',
                          textAlign: 'center',
                          label: 'Poids Exporté (KG)',
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={!(editMode && isEdit) ? 'input' : 'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} disabled={editMode && isEdit} value={row.poidExporte} error={!Utilities.isNumber(row.poidExporte) || row.poidExporte === 0} onChange={(evt) => onChangeEspecePoidExporte(row, 'poidExporte', evt.target.value)} />,
                        },
                        {
                          selector: 'codeSH',
                          textAlign: 'center',
                          label: 'Code SH',
                          component: (row) => (!(editMode && isEdit) ? <Input value={row.codeSH} onChange={({ target }) => onChangeEspeceData(row, 'codeSH', target.value)} /> : <>{row.codeSH}</>),
                        },
                        {
                          selector: 'autreTrans',
                          textAlign: 'center',
                          label: 'Autre Type Trans',

                          component: (row) => (!(editMode && isEdit) ? <Input disabled value={row.autreTrans} onChange={({ target }) => onChangeEspeceData(row, 'autreTrans', target.value)} /> : <>{row.autreTrans}</>),
                        },
                        {
                          selector: 'observations',
                          textAlign: 'center',
                          label: 'Observations',
                          component: (row) => (!(editMode && isEdit) ? <Input value={row.observations} onChange={({ target }) => onChangeEspeceData(row, 'observations', target.value)} /> : <>{row.observations}</>),
                        },

                        {
                          selector: 'rendementG',
                          textAlign: 'center',
                          label: 'Rendement G',
                          component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.rendementG} />,
                        },
                      ]}
                      data={source.allChildrenSrcEsp}
                      selectable={!editMode || !isEdit}
                      grouped={false}
                      pagination={true}
                      rowsPerPage={5}
                      striped={true}
                      sortable={true}
                      onSelectRows={(rows) => onSelectEspeces(rows)}
                    />
                  </>
                )}

                {source.childrenSrcEsp && source.childrenSrcEsp.length > 0 && (
                  <>
                    <Divider />
                    <Components.Tables.SmartTable
                      header={[
                        {
                          selector: 'refEspece.libelle',
                          label: 'Espece',
                        },
                        {
                          selector: 'disponible',
                          label: 'Total Disponible en (KG)',
                          component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.disponible} />,
                        },
                        {
                          selector: 'poidCD',
                          label: 'Total Poids CD (KG)',
                          component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.poidCD} />,
                        },
                        {
                          selector: 'poidExporte',
                          label: 'Total Poids Exporté (KG)',
                          component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.poidExporte} />,
                        },
                      ]}
                      data={source.childrenSrcEsp}
                      grouped={true}
                      groupeBy="refEspece.libelle"
                      groupeSums={['disponible', 'poidCD', 'poidExporte']}
                      rowsPerPage={5}
                      pagination={true}
                      striped={true}
                      sortable={false}
                      selectable={false}
                    />
                    <Button floated="right" loading={savingSourceExp} disabled={source.childrenSrcEsp.length === 0 || source.childrenSrcEsp.filter((el) => !el.codeSH).length > 0} onClick={() => onSaveSourceCP()} icon primary size="mini">
                      <Icon name="plus" />
                    </Button>
                  </>
                )}
              </Components.Regions.RegionWithHeader>
            </Grid.Column>
          </Grid>
          {modalData && <Components.Modals.Confirmation modalData={modalData} onConfirm={(data) => onDeleteSource(data)} onCancel={() => setModalData({ open: false })} />}
        </>
      )}
    </MPMContext.Consumer>
  );
};
